const setWorkerAction = ({ commit }, props): void => {
  commit("setWorker", props);
};

export default {
  setWorkerAction,
};
